<template>
  <router-link
    class="b44-link b44-doc-link"
    :to="{ name: 'documentacaoPortfolioAuditor', query }"
  >
    <i class="bi bi-book"></i>
    <span>{{ label }}</span>
  </router-link>
</template>

<script>
export default {
  name: "DocLink",
  props: {
    label: { type: String, default: "Manual" },
    from: { type: String, default: "portfolio" },
    projetoId: { type: [String, Number], default: null },
  },
  computed: {
    query() {
      const q = { from: this.from };
      if (this.projetoId != null) q.id = String(this.projetoId);
      return q;
    },
  },
};
</script>
